import { render, staticRenderFns } from "./GlobalTrend.vue?vue&type=template&id=c48a2c1a&scoped=true"
import script from "./GlobalTrend.vue?vue&type=script&lang=js"
export * from "./GlobalTrend.vue?vue&type=script&lang=js"
import style0 from "./GlobalTrend.vue?vue&type=style&index=0&id=c48a2c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48a2c1a",
  null
  
)

export default component.exports